<template>
    <tr :key="user.id" style="cursor: pointer">
        <td class="text-left">
         {{ user.fullname }}
        </td>
        <td class="text-left">
           {{ user.email }}
        </td>
        <td class="text-left">
            {{ userRoleName }}
        </td>
        <td class="text-right">
            <v-icon @click="editClicked" color="#D22321">mdi-pencil</v-icon>
            <v-icon @click="deleteClicked" color="#D22321">delete</v-icon>
        </td>
    </tr>
</template>

<script>
import rolesApi from '@/api/roles'
    export default {
        name: 'user-row',
        props: ['user'],
        data () {
            return {
              roles: null
            }
        },
      mounted() {
          this.getRoles()
      },

      computed: {
          userRoleName () {
            return this.roles && this.user && this.user.role ? Object.keys(this.roles).find(key => this.roles[key] === this.user.role.identifier): ''
          }
        },
        methods: {
            getRoles () {
              this.roles =  rolesApi.getRoles()
            },
            editClicked () {
                this.$emit('edit', this.user)
            },
            deleteClicked () {
                this.$emit('delete', this.user)
            }
        }
    }
</script>

<style scoped>

</style>
